import {
  take,
  fork,
  call,
  put,
  select,
} from 'redux-saga/effects';

import { apiGet } from './callApi';

import actionTypes from '../actionTypes';
import {
  successGameBoxMissions,
  failGameBoxMission, setGameBoxMissionCount
} from '../actionCreators/gameBoxMission';
import { getToken } from '../selectors';

import apiRoutes from '../../constants/apiRoutes';

function* getGameBoxMission(): any {
  try {
    const headers = {};
    const token = yield select(getToken);
    headers['x-access-token'] = JSON.stringify(token);
    const response = yield call(apiGet, 'REACT_APP_GAMEBOX_URL', apiRoutes.GAMEBOX, { token }, headers);
    const responseOfMissionCount = yield call(apiGet, 'REACT_APP_GAMEBOX_URL', apiRoutes.GAME_BOX_MISSION_COUNT, { token }, headers);
    if (response.data.success) {
      yield put(successGameBoxMissions(response.data.result));
      yield put(setGameBoxMissionCount(responseOfMissionCount.data.result?.count));
    } else {
      console.error(response?.data?.message?.description);
      yield put(failGameBoxMission(response?.data?.message?.description));
    }
  } catch (error) {
    yield put(failGameBoxMission(error));
  }
}

export default function* watchGameBoxMissionRequest() {
  while (true) {
    yield take(actionTypes.GAME_BOX_MISSION_REQUEST);
    yield fork(getGameBoxMission);
  }
}